import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export const alertError = ({
  error,
  message,
  titleText
}) => {
  FloatingAlertStore.addAlert({
    message,
    titleText,
    type: 'danger'
  });
  reportError({
    error
  });
};